import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { PermisosService } from "src/app/services/permisos.service";
import { PasswordModal } from "../pass-modal/pass-modal.component";
import { UsersService } from "../users.service";

export interface Section {
  name: string;
  desc: string;
  options: Permiso[];
}

export interface Permiso {
  id: string;
  desc: string;
}

@Component({
  selector: "app-form-user",
  templateUrl: "./form.component.html",
})
export class UsersForm implements OnInit {
  modulos: Section[] = [
    {
      name: "Admin",
      desc: "Modulos de admin",
      options: [
        { id: "admin_dash", desc: "Dashboard" },
        { id: "admin_alerts", desc: "Alertas" },
        { id: "admin_reportes", desc: "Reportes" },
      ],
    },
    {
      name: "Oficina",
      desc: "Modulos de oficina",
      options: [
        { id: "office_caja", desc: "Caja" },
        { id: "office_actas", desc: "Actas administrativas" },
        { id: "office_cartas", desc: "Cartas Compromiso" },
      ],
    },
    {
      name: "Unidades",
      desc: "Modulos de Unidades",
      options: [
        { id: "unit_lista", desc: "Listado" },
        { id: "unit_asignacion", desc: "Asignacion" },
        { id: "unit_entrega", desc: "Entrega a chofer" },
        { id: "unit_recibir", desc: "Recibir en taller" },
        { id: "unit_percances", desc: "Revision de percances" },
        { id: "unit_historial", desc: "Historial" },
      ],
    },
    {
      name: "Inventario",
      desc: "Modulos de Inventario",
      options: [
        { id: "warehouse_moves", desc: "Movimientos" },
        { id: "warehouse_inventario", desc: "Inventario" },
        { id: "warehouse_materials", desc: "Materiales" },
      ],
    },
    {
      name: "Taller",
      desc: "Modulos de Taller",
      options: [
        { id: "taller_programar", desc: "Programar" },
        { id: "taller_mant", desc: "Mantenimientos" },
        { id: "taller_campana", desc: "Campañas" },
        { id: "taller_historial", desc: "Historial" },
      ],
    },
    {
      name: "Trabajadores",
      desc: "Modulos de Trabajadores",
      options: [
        { id: "worker_index", desc: "Trabajadores" },
        { id: "worker_credenciales", desc: "Credenciales" },
        { id: "worker_banned", desc: "No recomendados" },
      ],
    },
    {
      name: "Catalogos",
      desc: "Modulos de Catalogos",
      options: [
        { id: "cats_tpmat", desc: "Tipo de materiales" },
        { id: "cats_tpserv", desc: "Tipo de servicios" },
        { id: "cats_tpunidad", desc: "Tipo de unidad" },
        { id: "cats_empresas", desc: "Empresas" },
        { id: "cats_plantas", desc: "Plantas" },
        { id: "cats_proveedores", desc: "Proveedores" },
        { id: "cats_funcion", desc: "Funcionamiento" },
        { id: "cats_usuarios", desc: "Usuarios" },
      ],
    },
  ];

  especiales: Section[] = [
    {
      name: "Trabajadores",
      desc: "Permisos especiales de Trabajadores",
      options: [
        {
          id: "spcl_worker_reingreso",
          desc: "Reingresar trabajadores en la lista NO REINGRESO",
        },
      ],
    },
    // {
    //   name: "Actas",
    //   desc: "Permisos especiales de Actas",
    //   options: [
    //     { id: "spcl_act_edit", desc: "Editar acta administrativa" },
    //     { id: "spcl_act_remove", desc: "Eliminar acta administrativa" },
    //   ],
    // },
    {
      name: "Recepcion/Entrega",
      desc: "Permisos especiales de Recepcion/Entrega",
      options: [
        { id: "spcl_recp_edit", desc: "Editar Recepcion/Entrega" },
        { id: "spcl_recp_remove", desc: "Eliminar Recepcion/Entrega" },
      ],
    },
    {
      name: "Usuarios",
      desc: "Permisos especiales de usuarios",
      options: [
        { id: "spcl_user_pass", desc: "Cambiar contrasenas de usuarios" },
      ],
    },
  ];

  dashWidgets: Permiso[] = [
    { id: "widget_resumen", desc: "Resumen de unidades" },
    { id: "widget_deudores", desc: "Tabla: Trabajadores con deudas" },
    { id: "widget_rojos", desc: "Tabla: Materiales debajo del minimo" },
  ];

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  @Output() onsave = new EventEmitter<{ mode: string; value: any }>();
  showChangePass: boolean = false;
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private service: UsersService,
    private permisosServ: PermisosService,
    private alerts: AlertasSwalService
  ) {}

  public ngOnInit() {
    if (this.permisosServ.getPermisos().includes("spcl_user_pass")) {
      this.showChangePass = true;
    }

    this.buildForm();
  }
  public fromInit(row: any) {
    this.form.controls["IdUsuario"].setValue(row?.IdUsuario);
    this.form.controls["Usuario"].patchValue(row?.Usuario);
    this.form.controls["Contrasena"].patchValue(row?.Contrasena);
    this.form.controls["Correo"].patchValue(row?.Correo);
    this.form.controls["Iniciales"].patchValue(row?.Iniciales);
    this.form.controls["Color"].patchValue("#000000");
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;

    const flatModulos = this.modulos
      .map((m) => m.options)
      .flat()
      .map((m) => m.id);

    const flatEspeciales = this.especiales
      .map((m) => m.options)
      .flat()
      .map((m) => m.id);

    const flatDash = this.dashWidgets.flat().map((m) => m.id);

    this.form.controls["IdUsuario"].setValue(row?.IdUsuario);
    this.form.controls["Usuario"].patchValue(row?.Usuario);
    this.form.controls["Correo"].patchValue(row?.Correo);
    this.form.controls["Iniciales"].patchValue(row?.Iniciales);
    this.form.controls["Color"].patchValue(row?.Color);
    this.form.controls["permisosSelected"].patchValue(
      row?.Permisos.filter((f) => flatModulos.includes(f))
    );
    this.form.controls["specialSelected"].patchValue(
      row?.Permisos.filter((f) => flatEspeciales.includes(f))
    );
    this.form.controls["widgetsSelected"].patchValue(
      row?.Permisos.filter((f) => flatDash.includes(f))
    );
    this.irArriba();
  }
  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public update() {
    this.onsave.emit({ mode: this.mode, value: this.form.value });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      IdUsuario: [],
      Usuario: [""],
      Contrasena: [""],
      Correo: [""],
      permisosSelected: [],
      specialSelected: [],
      widgetsSelected: [],
      Iniciales: [""],
      Color: ["#000000"],
    });
  }

  public openTab = 1;
  toggleTabs($tabNumber: number) {
    this.openTab = $tabNumber;
  }

  async openChangePass() {
    const result = await this.dialog
      .open(PasswordModal, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: {
          usuario: this.form.controls["Usuario"].value,
        },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.service
        .changePass({
          ...result,
          IdUsuario: this.defaults.IdUsuario,
        })
        .subscribe(
          (next) => {
            this.alerts.correcta(
              "Actualizado",
              "Accion realizada correctamente"
            );
          },
          (err) => {
            this.alerts.error("error", err.error.Message);
          }
        );
    }
  }

  irArriba() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  }
}
